import { render } from "./promocode.vue?vue&type=template&id=2d053e02"
import script from "./promocode.vue?vue&type=script&lang=js"
export * from "./promocode.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/resources/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__